import { motion } from "framer-motion";
import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesign";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesign";
import OurTeam from "../../homepage/OurTeam";
import Testimonials from "../../homepage/Testimonials";
import { useGlobalData } from "../../../contextApi/globalContextData";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";
import { useLanguage } from "../../../contextApi/languageContext";
import { useCart } from "../../../contextApi/cartContext";
import { painmanagement } from "../../../text-files/physiotherapy/painmanagement.ts";
const PainManagement = () => {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { language } = useLanguage();
  const { addToCart } = useCart();
  const content = painmanagement[language];
  const shared = painmanagement.shared;

  const treatments1 = [
    "Ankle Pain",
    "Joint Pain & Stiffness",
    "Neck Pain",
    "Heel Pain",
    "Tendinitis",
    "Fibromyalgia",
    "Back Pain",
    "Muscular",
    "Strains & Sprains",
    "Shoulder Pain",
  ];

  const treatments2 = [
    "Knee Pain",
    "Frozen Shoulder",
    "Elbow Pain",
    "Arthritis",
    "Headaches",
    "Migraines",
    "Chronic Pain",
    "Musculoskeletal Pain",
    "Nerve Pain",
    "Post-Surgical Pain",
  ];

  const artreatments1 = [
    "ألم الكاحل",
    "ألم وتيبس المفاصل",
    "ألم الرقبة",
    "ألم الكعب",
    "التهاب الأوتار",
    "الفيبروميالغيا (الألم العضلي الليفي)",
    "ألم الظهر",
    "ألم عضلي",
    "الشد والتمزق العضلي",
    "ألم الكتف",
  ];

  const artreatments2 = [
    "ألم الركبة",
    "الكتف المتجمدة",
    "ألم الكوع",
    "التهاب المفاصل",
    "الصداع",
    "الصداع النصفي",
    "الألم المزمن",
    "ألم العضلات والعظام",
    "ألم الأعصاب",
    "ألم ما بعد الجراحة",
  ];

  return (
    <>
      <title>Pain Management -</title>
      <meta
        name="description"
        content="Pain management is a critical aspect of healthcare that focuses on relieving discomfort, improving quality of life, and helping individuals regain mobility"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/pain-management/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Pain Management -" />
      <meta
        property="og:description"
        content="Pain management is a critical aspect of healthcare that focuses on relieving discomfort, improving quality of life, and helping individuals regain mobility"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/pain-management/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-13T14:25:48+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fesfegergerg.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fesfegergerg.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Pain Management" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Pain Management -" />
      <meta
        name="twitter:description"
        content="Pain management is a critical aspect of healthcare that focuses on relieving discomfort, improving quality of life, and helping individuals regain mobility"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/fesfegergerg.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Hero Image Section */}
        {shared.images.main && (
          <section className="overflow-hidden ">
            <div className="position-relative mb-3">
              <img
                src={shared.images.main}
                alt="pain management Dubai"
                className="img-fluid w-100 rounded mt-2 "
                style={{
                  height: "500px",
                  objectFit: "cover",
                  objectPosition: "top",
                  border: "2px solid #c69933",
                  borderRadius: "100px",
                }}
              />
            </div>
          </section>
        )}

        <div className="d-flex gap-4  w-100">
          <div
            className="rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            {/* Main Content Column */}

            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>

            {/* Title Section */}
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>

            <QuickNavigation />

            {/* How It Works Section */}
            {content.howItWorks.title && (
              <motion.section className="my-5">
                <h2 className="h2 fw-bold mb-4 text-center">
                  {content.howItWorks.title}
                </h2>
                {content.howItWorks.description && (
                  <p className="text-muted text-center">
                    {content.howItWorks.description}
                  </p>
                )}
              </motion.section>
            )}

            {/* Introduction Image */}
            {shared.images.introductionImage && (
              <motion.div className="my-5">
                <div className="text-center">
                  <img
                    src={shared.images.introductionImage}
                    alt="fat freezing treatment dubai"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "500px" }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </motion.div>
            )}

            {language === "en" ? (
              <div className="row">
                <div className="col-md-6">
                  <ul className="list-group list-group-flush">
                    {treatments1.map((item, index) => (
                      <li key={index} className="list-group-item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="list-group list-group-flush">
                    {treatments2.map((item, index) => (
                      <li key={index} className="list-group-item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">
                  <ul className="list-group list-group-flush">
                    {artreatments1.map((item, index) => (
                      <li key={index} className="list-group-item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul className="list-group list-group-flush">
                    {artreatments2.map((item, index) => (
                      <li key={index} className="list-group-item">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {/* Process Section */}
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {/* {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )} */}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default PainManagement;
